var React = require('react');

function Component (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.7638 4.40434C16.769 4.737 19.9727 2.78112 23.6466 1.73383C23.9985 1.26426 24.6439 0.616138 25.0307 0.866043C25.4493 1.13645 25.7439 1.5951 26.1648 1.88C26.9375 2.40293 27.8187 2.75778 28.6307 3.21083C32.7597 5.51455 32.5593 9.51838 31.0862 13.6145C29.6938 17.4862 27.1152 19.8331 22.9498 19.8567C20.8866 19.8684 18.7787 19.5272 16.7279 19.3286C13.8261 19.0475 10.8799 18.8276 8.10254 17.8604C4.81945 16.7172 2.13589 14.6049 1.17311 11.1007C0.548478 8.82725 0.902659 6.59525 2.45287 4.79514C5.20524 1.59908 9.37412 4.12281 12.7638 4.40434Z","fill":"currentColor"}));
}

Component.defaultProps = {"width":"33","height":"20","viewBox":"0 0 33 20","fill":"none"};

module.exports = Component;

Component.default = Component;
